import React, { useState } from 'react';
import styled from 'styled-components';
import Autosuggest from 'react-autosuggest';
import SearchIcon from '../assets/icons/search.svg';

const StyledWrapper = styled.div`

    width: ${props => props.width};
    margin-right: ${props => props.marginRight};

    & .react-autosuggest__container {
        position: relative;
        width: 100%; 
    }

    & .react-autosuggest__input {
        outline: none;
        width: 100%;
        font-size: 16px;
        background-color: #000000;
        color: #ffffff;
        min-height: 39px;
        border: 0;
        border-radius: 0;
        border-bottom: 1px solid #808080;
        transition: 0.25s border-bottom;
        background: no-repeat right 0px center url('${SearchIcon}');
    }

    & .react-autosuggest__input:disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    & .react-autosuggest__input:hover {
        border-bottom: 1px solid #ffffff;
    }

    & .react-autosuggest__input:hover {
        border-bottom: 1px solid #ffffff;
    }

    & .react-autosuggest__input--open {
        
    }

    & .react-autosuggest__suggestions-container--open {
        display: block;
        position: absolute;
        font-family: 'Roboto Condensed', 'sans-serif';
        font-size: 14px;
        font-weight: 700;
        border-top: 3px solid #d6001c;
        top: 41px;
        width: 102%;
        background-color: #161718;
        box-shadow: 0 2px 10px 5px rgba(0,0,0,0.52);
        z-index: 2;
    }

    .react-autosuggest__suggestion {
        color: #FFFFFF;
        text-transform: uppercase;
        padding: 15px 0 15px 20px;
    }

    .react-autosuggest__suggestion--highlighted {
        background-color: #000000;
    }
`;

export const AutoCompleteInput = ({ value, width, setValue, marginRight, placeholder, disabled, type, values, onSelected, getSuggestions, renderSuggestion, getSuggestionValue }) => {
    const [ suggestions, setSuggestions ] = useState('');

    const onChange = (event, { newValue }) => {
        setValue(typeof newValue !== 'undefined' ? newValue : '');
    }

    const onSuggestionsFetchRequested = ({ value }) => {
        setSuggestions(getSuggestions(value, values));
    };

    const onSuggestionsClearRequested = () => {
        setSuggestions([]);
    };

    const inputProps = {
        placeholder,
        value,
        onChange,
        disabled,
    };

    return (
        <StyledWrapper width={width} marginRight={marginRight} > 
            <Autosuggest
                onSuggestionSelected={onSelected}
                suggestions={suggestions}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={inputProps}
            />
        </StyledWrapper>
    );
}

export default AutoCompleteInput;